const e = "externalUrl";
export {
  e as MENU_EXTERNAL_URL
};
